import {
	Stack,
	StackProps
} from "@mui/material"

import { ConventionsSessionResult } from 'interface/convention'
import { ConventionsSessionsLine } from './line'

type ConventionSessionsBodyProps = {
	sessionList: ConventionsSessionResult[],
	onClickedSpeaker: (kojinCode: string) => void
} & StackProps

export const ConventionsSessionsBody = ({
	sessionList,
	onClickedSpeaker,
	...others
} : ConventionSessionsBodyProps) => {
	return (
		<Stack overflow='auto' maxHeight='100%' spacing={2} {...others}>
			{ sessionList.map((session, i) => 
				<ConventionsSessionsLine
					key={`session-line-${session.sessionId}-${i}`}
					session={session}
					onClickedSpeaker={onClickedSpeaker}
				/>
			)}
		</Stack>
	)
}